import React from 'react';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

// TODO: implement actual modal content
export const ThirdPartyAuthenticationModal = () => {
	const { Modal } = useChoreographerAssets();

	return (
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		<Modal>hello</Modal>
	);
};
